import { createEntityAdapter } from '@ngrx/entity';
import { PatrimoineHierarchieTemplateEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<PatrimoineHierarchieTemplateEntityState>;

export const adapter = createEntityAdapter<PatrimoineHierarchieTemplateEntityState>({
  selectId: o => o.idPatrimoineHierarchieTemplate
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const patrimoineHierarchieTemplateFeatureKey = 'patrimoineHierarchieTemplate';
